/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptCampaignConfig } from '../models/V3StackAdaptCampaignConfig';
import { V3StackAdaptCampaignGroupConfig } from '../models/V3StackAdaptCampaignGroupConfig';
import { V3StackAdaptCampaignUpdateStatus } from '../models/V3StackAdaptCampaignUpdateStatus';
import { V3StackAdaptCreativeMap } from '../models/V3StackAdaptCreativeMap';
import { V3StackAdaptCreativeTactic } from '../models/V3StackAdaptCreativeTactic';
import { V3StackAdaptGoal } from '../models/V3StackAdaptGoal';
import { V3StackAdaptLibraryAd } from '../models/V3StackAdaptLibraryAd';
import { V3StackAdaptSegmentMap } from '../models/V3StackAdaptSegmentMap';
import { HttpFile } from '../http/http';

/**
* Configuration for a StackAdapt deploy destination. Note for self - this is the config field
*/
export class V3StackAdaptCampaign {
    'camapignGroup'?: V3StackAdaptCampaignGroupConfig;
    'campaign'?: V3StackAdaptCampaignConfig;
    /**
    * The type of campaign in StackAdapt. One of: audio, ctv, display, dooh, native, or video
    */
    'campaignType'?: string;
    'segmentMap'?: V3StackAdaptSegmentMap;
    'updateStatus'?: V3StackAdaptCampaignUpdateStatus;
    /**
    * A list of library ads that will be used in the campaign
    */
    'libraryAds'?: Array<V3StackAdaptLibraryAd>;
    'creativeMap'?: V3StackAdaptCreativeMap;
    /**
    * The sponsored by text for the campaign
    */
    'sponsoredBy'?: string;
    /**
    * A list of goals for the campaign
    */
    'goals'?: Array<V3StackAdaptGoal>;
    /**
    * A list of creative tactics for the campaign
    */
    'creativeTactics'?: Array<V3StackAdaptCreativeTactic>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "camapignGroup",
            "baseName": "camapign_group",
            "type": "V3StackAdaptCampaignGroupConfig",
            "format": ""
        },
        {
            "name": "campaign",
            "baseName": "campaign",
            "type": "V3StackAdaptCampaignConfig",
            "format": ""
        },
        {
            "name": "campaignType",
            "baseName": "campaign_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "segmentMap",
            "baseName": "segment_map",
            "type": "V3StackAdaptSegmentMap",
            "format": ""
        },
        {
            "name": "updateStatus",
            "baseName": "update_status",
            "type": "V3StackAdaptCampaignUpdateStatus",
            "format": ""
        },
        {
            "name": "libraryAds",
            "baseName": "library_ads",
            "type": "Array<V3StackAdaptLibraryAd>",
            "format": ""
        },
        {
            "name": "creativeMap",
            "baseName": "creative_map",
            "type": "V3StackAdaptCreativeMap",
            "format": ""
        },
        {
            "name": "sponsoredBy",
            "baseName": "sponsored_by",
            "type": "string",
            "format": ""
        },
        {
            "name": "goals",
            "baseName": "goals",
            "type": "Array<V3StackAdaptGoal>",
            "format": ""
        },
        {
            "name": "creativeTactics",
            "baseName": "creative_tactics",
            "type": "Array<V3StackAdaptCreativeTactic>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCampaign.attributeTypeMap;
    }

    public constructor() {
    }
}

